"use strict";

//todo: First day of week
//todo: Date & Time format
//todo: formatter functions to separated object
//todo: leading zeroes function
//todo: p->label?

import "./DateTimePicker.css";
import Picker from "./../Picker";
import Button from "./../Button";
import Select from "./../Select";
import Input from "./../Input";
import lang from "./../../lang";
import React from "react";

export default class DateTimePicker extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		let dt = {};
		if(!this.getDateAvailability(this.props.dateTime)){
			dt = new Date(this.props.minDate);
		}
		else{
			dt = new Date(this.props.dateTime);
		}
		
		dt.setSeconds(0);
		
		this.state = {
			timeFormat: this.props.timeFormat || this.determineTimeFormat(), // 12H vagy 24H
			dateTime: dt,
			currentYearAndMonth: dt,
			textInputValue: this.formatDate(dt)
		};
	}

	determineTimeFormat(){
		if(/(am|pm)/.test(new Date().toLocaleTimeString().toLowerCase())){
			return "12H";
		}
		
		return "24H";
	}
	
	getFormattedMonth(datetime){
		return ('0' + (datetime.getMonth() + 1)).slice(-2);
	}

	getFormattedDays(datetime){
		return ('0' + datetime.getDate()).slice(-2);
	}

	get12HFormattedHours(datetime){
		var hour = datetime.getHours() % 12;
		if(hour == 0){
			return 12;
		}
		else{
			return hour;
		}
	}

	getFormattedMinutes(datetime){
		return ('0' + datetime.getMinutes()).slice(-2);
	}

	getAMPM(datetime){
		return (datetime.getHours() >= 12 ? "PM" : "AM");
	}
	
	formatDate(datetime){
		let s;
		
		if(this.state && this.state.timeFormat == "12H"){
				s	= datetime.getFullYear() + "/"
					+ this.getFormattedMonth(datetime) + "/"
					+ this.getFormattedDays(datetime) + " "
					+ this.get12HFormattedHours(datetime) + ":"
					+ this.getFormattedMinutes(datetime) + " "
					+ this.getAMPM(datetime);
		}
		else{
				s	= datetime.getFullYear() + "/"
					+ this.getFormattedMonth(datetime) + "/"
					+ this.getFormattedDays(datetime) + " "
					+ datetime.getHours() + ":"
					+ this.getFormattedMinutes(datetime);
		}
		
		return s;
	}
	
	shiftCurrentMonth(val){
		const dt = this.state.currentYearAndMonth;
		dt.setMonth(dt.getMonth() + val);
		this.setState({ currentYearAndMonth: dt });
	}
	
	shiftCurrentYear(val){
		const dt = this.state.currentYearAndMonth;
		dt.setFullYear(dt.getFullYear() + val);
		this.setState({ currentYearAndMonth: dt });
	}
	
	getCalendarRowsArray(){		
		const calendarRowsArray = [];
		const firstDay = new Date(this.state.currentYearAndMonth.getFullYear(), this.state.currentYearAndMonth.getMonth(), 1).getDay();
		const numberOfDaysInCurrentMonth = new Date(this.state.currentYearAndMonth.getFullYear(), this.state.currentYearAndMonth.getMonth()+1, 0).getDate();
		let weekDayCount = 0;
		let calendarRow = [];
		
		for(let i=0; i<firstDay; i++){
			calendarRow[i] = 0;
			weekDayCount++;
		}
		
		for(let i=1; i<=numberOfDaysInCurrentMonth; i++){
			if(weekDayCount == 7){
				calendarRowsArray.push(calendarRow);
				calendarRow = [];
				weekDayCount = 0;
			}
			calendarRow.push(i);
			weekDayCount++;
		}
		if(calendarRow.length != 0){
			calendarRowsArray.push(calendarRow);
		}
		
		return calendarRowsArray;
	}
	
	getDateAvailability(date){
		if((this.props.minDate == null || this.props.minDate.getTime() < date.getTime()) &&
		   (this.props.maxDate == null || this.props.maxDate.getTime() > date.getTime())){
			return true;
		}
		return false;
	}
	
	setDate(day){
		const year = this.state.currentYearAndMonth.getFullYear();
		const month = this.state.currentYearAndMonth.getMonth();
		const dt = new Date(year, month, day);
		dt.setHours(this.state.dateTime.getHours());
		dt.setMinutes(this.state.dateTime.getMinutes());
		this.setState({ dateTime: dt, textInputValue: this.formatDate(dt) });
		this.props.onChange(dt);
	}
	
	setTime(params){
		
		params = params || {};
		
		const hours = params.hours || (this.state.timeFormat == "12H" ? this.get12HFormattedHours(this.state.dateTime) : this.state.dateTime.getHours());
		const minutes = params.minutes || this.state.dateTime.getMinutes();
		
		const ampm = params.ampm || this.getAMPM(this.state.dateTime);
		
		const newDateTimeString = this.state.dateTime.getFullYear() + " " +
								(this.state.dateTime.getMonth() + 1) + " " + 
								this.state.dateTime.getDate() + " " + 
								hours + ":" + 
								minutes + 
								(this.state.timeFormat == "12H" ? (" " + ampm) : "");
		const dt = new Date(newDateTimeString);
		
		this.setState({ dateTime: dt, textInputValue: this.formatDate(dt) });
		this.props.onChange(dt);
		
	}
	
	handleInputChange(value){
		
		const dt = new Date(value);
		
		this.setState({ textInputValue: value });
		
		if(isNaN(dt.getTime()) || !this.getDateAvailability(dt)){
			return;
		}
		else{
			this.setState({ dateTime: dt, currentYearAndMonth: dt });
			this.props.onChange(dt);
		}
		
	}
	
	componentWillReceiveProps(nextProps){
		this.setState({textInputValue: this.formatDate(nextProps.dateTime)}); 
		this.setState({dateTime: nextProps.dateTime});
	}
	
	renderHeader(){
		return(
			<header>
				<Button icon="menu-left" onClick={() => {this.shiftCurrentYear(-1)}} />
				<label className="Year">{this.state.currentYearAndMonth.getFullYear()}</label>
				<Button icon="menu-right" onClick={() => {this.shiftCurrentYear(+1)}} />
				<Button icon="menu-left" onClick={() => {this.shiftCurrentMonth(-1)}} />
				<label className="Month">{lang["MONTH_" + this.state.currentYearAndMonth.getMonth()]}</label>
				<Button icon="menu-right" onClick={() => {this.shiftCurrentMonth(+1)}}/>
			</header>
		)
	}
	
	renderDay(day){
		const today = new Date();
		const date = (new Date(this.state.currentYearAndMonth))
		date.setDate(day);
		
		let className = "";
		
		if( date.getFullYear() == this.state.dateTime.getFullYear() &&
			date.getMonth() == this.state.dateTime.getMonth() &&
			date.getDate() == this.state.dateTime.getDate()){
			className = "Selected";
		}
		else if(date.getFullYear() == today.getFullYear() &&
				date.getMonth() == today.getMonth() &&
				date.getDate() == today.getDate()){
			className = "Today";
		}
		
		if(day != 0){		
			return(
				<td key={day}>
					<Button disabled={!this.getDateAvailability(date)} key={day} className={className} onClick={() => {this.setDate(day)}}>
						{day}
					</Button>
				</td>
			)
		}
		else{
			return (<td key={Math.random()}></td>);
		}
	}
	
	renderCalendarRow(week){
		return(
			<tr key={week[0]}>
				{
					week.map( day => this.renderDay(day) )
				}
			</tr>
		);
	}
	
	renderCalendar(){
		const calendarRowsArray = this.getCalendarRowsArray();
		
		return(
			<table>
				<thead>
					<tr>
						<th>S</th>
						<th>M</th>
						<th>T</th>
						<th>W</th>
						<th>T</th>
						<th>F</th>
						<th>S</th>
					</tr>
				</thead>
				<tbody>
					{
						calendarRowsArray.map(week => this.renderCalendarRow(week))
					}
				</tbody>
			</table>
		)
	}
	
	renderAMPMSelector(){
		if(this.state.timeFormat == "12H"){
			return(
				<Select 
					required
					value={this.getAMPM(this.state.dateTime)}
					onChange={evt => this.setTime({ampm: evt.target.value})}
				>
					<option value="AM">AM</option>
					<option value="PM">PM</option>
				</Select>
			);
		}
		else{
			return null;
		}
	}
	
	renderFooter(){
		const hoursInputProps = {
			type: "number",
			min: this.state.timeFormat == "12H" ? "1" : "0",
			max: this.state.timeFormat == "12H" ? "12" : "23",
			value: this.state.timeFormat == "12H" ? this.get12HFormattedHours(this.state.dateTime) : this.state.dateTime.getHours(),
			onChange: evt => this.setTime({hours: evt.target.value})
		}
		
		const minutesInputProps = {
			type: "number",
			min: "0",
			max: "59",
			value: this.getFormattedMinutes(this.state.dateTime),
			onChange: evt => this.setTime({minutes: evt.target.value})
		}
		
		return(
			<footer>
				<div>
					<label>Time:</label>
					<Input {...hoursInputProps}/>
					<label>:</label>
					<Input {...minutesInputProps}/>
					{this.renderAMPMSelector()}
				</div>
				<div>
					<Button onClick={ () => {
							const dt = new Date();
							this.setState({
								dateTime: dt,
								currentYearAndMonth: dt,
								textInputValue: this.formatDate(dt)
							});
							this.props.onChange(dt);
						} 
					}>{lang.NOW}</Button>
					<Button onClick={ () => {this.setState({picker: false})} }>{lang.DONE}</Button>
				</div>
			</footer>
		)
	}
	
	render(){
		const inputProps = {
			ref: "input",
			onClick: () => this.setState({picker: !this.state.picker && !this.state.disabled}),
			value: this.state.textInputValue,
			onChange: evt => {
				this.handleInputChange(evt.target.value);
			},
			onBlur: () => {
				this.setState({textInputValue: this.formatDate(this.state.dateTime)});
			},
			disabled: this.state.disabled,
			className: "DateTimePicker"
		};
		
		const pickerProps = {
			shown: this.state.picker,
			onWindowClick: () => this.setState({picker: false}),
			className: "DateTimePicker"
		};
		
		return(
		<div className="DateTimePicker">
			<Input {...inputProps}/>
			<Picker {...pickerProps}>
				{this.renderHeader()}
				{this.renderCalendar()}
				{this.renderFooter()}
			</Picker>
		</div>);
	}
}

DateTimePicker.propType = {
	timeFormat:	React.PropTypes.string,
	dateTime:	React.PropTypes.object,
	onChange:	React.PropTypes.func,
	minDate:	React.PropTypes.object,
	maxDate:	React.PropTypes.object,
	disabled:	React.PropTypes.boolean
};

DateTimePicker.defaultProps = {	
	timeFormat:	null,
	dateTime:	new Date(),
	onChange:	dateTime => {},
	minDate:	null,
	maxDate:	null,
	disabled:	false
};


// WEBPACK FOOTER //
// ./~/vwa/components/DateTimePicker/DateTimePicker.jsx